import { createBrowserRouter, Route, createRoutesFromElements } from 'react-router-dom';

// Local Components
import Layout from './Layout';
import EventDiscoveryPage from '../pages/EventDiscoveryPage';
import EventDetailsPage from '../pages/EventDetailsPage';
import EventTicketPage from '../pages/EventTicketPage';
import Homepage from '../pages/Homepage';
import BookingBreakup from '../components/Tables/BookingBreakup';
import TicketBooked from '../components/TicketDiscovery/TicketBooked';
import TicketError from '../components/UiComponent/TicketError';
import PurchaseTicket from '../components/UiComponent/PurchaseTicket';
import VenueDiscovery from '../components/VenueDiscovery/VenueDiscovery';
import FoodAndDrinks from '../components/VenueDiscovery/FoodAndDrinks';
import SportsAndFitness from '../components/VenueDiscovery/SportsAndFitness';
import BusinessAndProfessional from '../components/VenueDiscovery/BusinessAndProfessional';
import Halls from '../components/VenueDiscovery/Halls';
import Auditoriums from '../components/VenueDiscovery/Auditoriums';
import Studios from '../components/VenueDiscovery/Studios';
import PartyPlots from '../components/VenueDiscovery/PartyPlots';
import ResetPasswordForm from '../view/authentication/login/ResetPasswordForm';
import AuthActions from '../view/authentication/auth-actions/AuthActions';
import NotFound404 from '../pages/404/NotFound.jsx';
import EventPreview from '../view/dashboard/manage/Event/manage-details/event-details/EventPreview.jsx';
import VerifyInviteCode from '../pages/verify-invite-code/VerifyInviteCode.jsx';
import EventDiscovery from '../pages/event/EventDiscovery.jsx';
import TicketOrderPayment from '../view/application/ticket-booking/TicketOrderPayment.jsx';
import TestQrCode from '../components/TestingComponents/TestQrCode.jsx';

// Saas Pages
import TermsAndConditions from '../pages/saas-pages/TermsAndConditions.jsx';
import RefundPolicy from '../pages/saas-pages/RefundPolicy.jsx';
import PrivacyPolicy from '../pages/saas-pages/PrivacyPolicy.jsx';
import ContactUs from '../pages/contact-us/ContactUs.jsx';
import Pricing from '../pages/saas-pages/Pricing.jsx';

// Event Attendance
import EventAttendance from '../view/application/event-attendance/EventAttendance.jsx';

import userDashboardRoutes from './user-dashboard/userDashboardRoutes.js';
import eventDashboardRoutes from './event-routes/eventDashboardRoutes.js';
import eventRoutes from './event-routes/eventRoutes.js';

const routes = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/pages/validate/event/invitation/:inviteCode" element={<VerifyInviteCode />} />

            <Route path="/pages/event-attendance/scanning" element={<EventAttendance />} />

            {/* Event Preview */}
            <Route path="/pages/event-preview/:eventSlug" element={<EventPreview />} />

            {/* Auth actions url */}
            <Route path="/auth/action" element={<AuthActions />} />

            {/* Reset Password */}
            <Route path="/pages/reset-password/:oobCode" element={<ResetPasswordForm />} />

            <Route element={<Layout />}>
                <Route path="/" element={<Homepage />} />

                {/* New Event Disocvery */}
                <Route path="/events" element={<EventDiscovery />} />

                {/* <Route path="/event-discovery" element={<EventDiscoveryPage />} />

                <Route path="/event-detail-page/:eventId" element={<EventDetailsPage />} />

                <Route path="/event-ticket-page/:eventId" element={<EventTicketPage />} /> */}

                {/* Event Ticket Page */}
                <Route path="/booking" element={<BookingBreakup />} />

                {/* Event Booking Success Page */}
                <Route path="/success" element={<TicketBooked />} />

                {/* Event Booking Error Page */}
                <Route path="/error" element={<TicketError />} />

                {/* Purchase Ticket Page */}
                <Route path="/ticket" element={<PurchaseTicket />} />

                {/* Venue Card */}
                <Route path="/venue" element={<VenueDiscovery />} />

                {/* Food and Drinks */}
                <Route path="/food-and-drinks" element={<FoodAndDrinks />} />

                {/* Sports and Fitness */}
                <Route path="/sports-and-fitness" element={<SportsAndFitness />} />

                {/* Business and Professional */}
                <Route path="/business-and-professional" element={<BusinessAndProfessional />} />

                {/* Halls */}
                <Route path="/halls" element={<Halls />} />

                {/* Auditoriums */}
                <Route path="/auditoriums" element={<Auditoriums />} />

                {/* Studios */}
                <Route path="/studios" element={<Studios />} />

                {/* Party Plots */}
                <Route path="/party-plots" element={<PartyPlots />} />

                {/* Payment Success Page of Ticket Booking */}
                <Route path="/event/ticket/order/:bookingId" element={<TicketOrderPayment />} />

                {/* Temp Route to test qr code generation and mapping */}
                <Route path="/qrcode" element={<TestQrCode />} />

                <Route path="/pages/terms-and-conditions" element={<TermsAndConditions />} />

                <Route path="/pages/refund-policy" element={<RefundPolicy />} />

                <Route path="/pages/privacy-policy" element={<PrivacyPolicy />} />

                <Route path="/pages/contact-us" element={<ContactUs />} />

                <Route path="/pages/pricing" element={<Pricing />} />
            </Route>

            {eventRoutes}

            {eventDashboardRoutes}

            {userDashboardRoutes}

            <Route path="*" element={<NotFound404 />} />
        </>
    )
);

export default routes;